import { useParams, useNavigate } from "react-router-dom";
import SpectateBoutView from "../components/SpectateBoutView";

export default function SpectateView() {
  const { eventId, boutId } = useParams();
  const navigate = useNavigate();

  return <SpectateBoutView eventId={eventId} boutId={boutId} onExit={() => navigate("/spectate")} />;
}
